export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {
      pageTitle: 'Dashboard',
      subject: 'dashboard',
      action: 'read',
      hasSettings: true
    }
  },
]
